// extracted by mini-css-extract-plugin
export default {"monthlyStats":"MonthlyStats--monthlyStats--EiXhD","currMonthStats":"MonthlyStats--currMonthStats--OiHnr","barChart":"MonthlyStats--barChart--cXWnK"};